import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Student Analytics — Owner
 * GET /students/analytics?period=&classId=&sectionId=
 */
export const getStudentAnalytics = async (params = {}) => {
  const res = await axiosInstance.get("/students/analytics", { params });
  return res.data;
};

/**
 * Student Analytics — Portal
 * GET /student-portal/analytics?period=&classId=&sectionId=
 */
export const getStudentAnalyticsPortal = async (params = {}) => {
  const res = await axiosInstance.get("/student-portal/analytics", { params });
  return res.data;
};
